// PSO Release 07: cached theme-owned sizing controller; behavior retained.
// CHANGE LOG BY DEVESH 2026-09-14: readCache() no longer reads localStorage — the chart inlined with the page is the only source, so a chart deleted or reassigned in Lister stops painting from a 7-day cache.
// 2026-09-12: render from the theme's own kiwi-charts.json instead of waiting on Kiwi's remote
// widget. The seed already held the data; it was only warming localStorage while the table sat
// behind a MutationObserver on Kiwi's injected DOM. Kiwi stays as the fallback for unknown ids.
(() => {
const psoConfig = JSON.parse(document.currentScript.dataset.psoConfig);
/* ===== KIWI SIZING MASTER CONTROLLER (UNIFIED) ===== */
(function(){
  const SIZE_LOOKUP = ['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
  const block = document.querySelector('.atc-main');
  if (!block) return;

  const CACHE_KEY = 'kiwiDataV3:' + (block.getAttribute('data-cache-key') || location.pathname);
  const KIWI_CHART_ID = String(psoConfig.chartId || '').trim();   // 2026-09-12: 16 products store the id with a trailing newline
  const CACHE_KEY_C = KIWI_CHART_ID ? ('kiwiDataV3C:' + KIWI_CHART_ID) : null;
  const CACHE_TTL = 1000 * 60 * 60 * 24 * 7; // 7 days

  let globalPayload = null;
  let isModalLoading = false; 
  let currentUnit = 'IN'; // Current active unit for size chart

  // Modal elements
  const productTitle = psoConfig.title;
  const modal = document.getElementById('ksc-modal');
  const backdrop = document.getElementById('ksc-backdrop');
  const tableEl = modal.querySelector('.ksc-table');
  const titleEl = modal.querySelector('#ksc-title');
  const addBtn = modal.querySelector('#ksc-add');
  const unitToggle = document.getElementById('ksc-unit-toggle');
  const readoutEl = block.querySelector('.inline-size-meta');
  const variantInput = document.querySelector('form.atc-form #variantId') || document.querySelector('form.atc-form [name="id"]');
  
  const sizeToVariant = {};
  const sizeOOS = {};
  block.querySelectorAll('.variant-btn').forEach(b => {
    const s = (b.getAttribute('data-value') || b.textContent || '').trim().toUpperCase();
    sizeToVariant[s] = b.getAttribute('data-variant-id') || null;
    sizeOOS[s] = b.classList.contains('out-of-stock') || b.disabled;
  });

  let selectedSize = null;

  /* --- Utils --- */
  function norm(t){ return (t||'').replace(/\s+/g,' ').trim(); }
  function upper(t){ return norm(t).toUpperCase(); }
  
  function pickFirstHeader(headers, patterns){
    for (const rx of patterns){
      const h = headers.find(H => rx.test(H));
      if (h) return h;
    }
    return null;
  }

  // Conversion logic for IN -> CM
  function convertValue(val, unit) {
    if (!val) return '';
    if (unit === 'IN') return val; // preserve original formatting
    // convert IN numbers to CM
    return val.replace(/(\d+(?:\.\d+)?)\s*\"?/g, function(match, numString) {
      let cmVal = parseFloat(numString) * 2.54;
      return (cmVal % 1 === 0 ? cmVal : cmVal.toFixed(1)); 
    });
  }

  /* --- Cache Management --- */
  // 2026-08-11: a chart cached BEFORE a new size was added (e.g. 3XL) served that chip with no
  // range for up to the full TTL. If the cache is missing a rendered size, skip it ONCE per
  // session so a live refetch heals it (once-only guard stops charts that genuinely lack the
  // size from refetching on every view).
  function cacheCovers(obj, key){
    try{
      const need = Array.from(document.querySelectorAll('.inline-size-atc .variant-btn'))
        .map(b => upper(b.getAttribute('data-value') || b.textContent)).filter(Boolean);
      if (!need.length) return true;
      const rows = obj.rows || [];
      if (need.every(sz => rows.some(r => r.SIZE === sz))) return true;
      const fk = 'kiwiReFetched:' + (key || KIWI_CHART_ID || CACHE_KEY);
      if (sessionStorage.getItem(fk)) return true;
      sessionStorage.setItem(fk, '1');
      return false;
    }catch(_){ return true; }
  }
  function readCache(){
    // 2026-09-14: the chart ships inline with the page, so the page is the only source. The
    // localStorage copy dated from waiting on Kiwi's widget; reading it painted charts that had
    // since been deleted or reassigned in Lister. Writes stay (collection popups read by chart id).
    return null;
    // eslint-disable-next-line no-unreachable
    try{
      const keys = [CACHE_KEY_C, CACHE_KEY];
      for (let i = 0; i < keys.length; i++){
        const k = keys[i]; if(!k) continue;
        const raw = localStorage.getItem(k); if(!raw) continue;
        const obj = JSON.parse(raw);
        if(!obj || !obj.rows || !obj.headers || !obj.ts) continue;
        if(Date.now() - obj.ts > CACHE_TTL) continue;
        if(!cacheCovers(obj, k)) continue;
        return obj;
      }
      if (KIWI_CHART_ID){
        // cross-engine fallback: popups/overlay store {headers, rows:{SIZE:{H:v}}} under saadaaKiwiC
        const raw = localStorage.getItem('saadaaKiwiC:' + KIWI_CHART_ID);
        if (raw){
          const o = JSON.parse(raw);
          if (o && o.rows && o.headers && (Date.now() - o.ts) <= CACHE_TTL){
            const rows = Object.keys(o.rows).map(sz => Object.assign({ SIZE: String(sz).toUpperCase() }, o.rows[sz]));
            if (rows.length){
              const cand = { ts: o.ts, headers: ['SIZE'].concat(o.headers), rows: rows };
              if (cacheCovers(cand, 'saadaaKiwiC:' + KIWI_CHART_ID)) return cand;
            }
          }
        }
      }
      return null;
    }catch(_){ return null; }
  }
  function writeCache(payload){
    try{
      const v = JSON.stringify({ts:Date.now(), ...payload});
      localStorage.setItem(CACHE_KEY, v);
      if (CACHE_KEY_C) localStorage.setItem(CACHE_KEY_C, v);
      if (KIWI_CHART_ID){
        const ro = {};
        (payload.rows || []).forEach(rec => {
          const sz = String(rec.SIZE || '').toUpperCase(); if (!sz) return;
          const c = {}; Object.keys(rec).forEach(k => { if (k !== 'SIZE') c[k] = rec[k]; });
          ro[sz] = c;
        });
        if (Object.keys(ro).length) localStorage.setItem('saadaaKiwiC:' + KIWI_CHART_ID, JSON.stringify({ ts: Date.now(), headers: (payload.headers || []).filter(h => h !== 'SIZE'), rows: ro }));
      }
    }catch(_){}
  }

  /* --- DOM Extraction --- */
  function getHeaderCells(t){
    const thead = t.querySelector('thead');
    if (thead) return Array.from(thead.querySelectorAll('th,td')).map(th=>upper(th.textContent));
    const first = t.querySelector('tr');
    if (!first) return [];
    return Array.from(first.children).map(td=>upper(td.textContent));
  }

  function extractFromDOM(){
    const roots = [
      document.querySelector('#KiwiSizingModal'),
      document.querySelector('.kiwiSizingModal'),
      ...document.querySelectorAll('[class*="Kiwi"][class*="Modal"], [class*="kiwi"][class*="modal"]'),
      document
    ].filter(Boolean);
    
    let tables = [];
    for (const r of roots) {
      tables.push(...r.querySelectorAll('table'));
      if (tables.length) break;
    }
    tables = Array.from(new Set(tables));

    let best = null, bestScore = -1;
    for (const t of tables){
      const headersRaw = getHeaderCells(t);
      if (headersRaw.length < 2) continue;
      const headers = headersRaw.map(h=>h.replace(/\s+/g,' ').trim());
      let sizeCol = headers.findIndex(h=>/^SIZE$/.test(h));
      if (sizeCol < 0) sizeCol = 0;

      const bodyRows = t.querySelectorAll('tbody tr');
      const rowsEls = bodyRows.length ? bodyRows : t.querySelectorAll('tr');
      const records = [];

      rowsEls.forEach((tr, idx)=>{
        if (!bodyRows.length && idx===0) return;
        const cells = Array.from(tr.children);
        if (!cells.length) return;
        const sizeText = upper(norm(cells[sizeCol]?.textContent || ''));
        if (!SIZE_LOOKUP.includes(sizeText)) return;

        const rec = { SIZE:sizeText };
        cells.forEach((td,i)=>{
          if (i===sizeCol) return;
          const key = headers[i] || ('COL'+i);
          rec[key] = norm(td.textContent);
        });
        records.push(rec);
      });

      if (records.length > bestScore) {
        bestScore = records.length;
        best = { headers, rows: records };
      }
    }
    return best;
  }

  /* --- Apply to Swatches --- */
 function hydrateSwatches(payload) {
        const { rows, headers } = payload;
        const btns = block.querySelectorAll('.inline-size-atc .variant-btn');

        let headerPriority = [/\bCHEST\b/, /\bBUST\b/, /\bWAIST\b/, /\bHIPS?\b/, /\b(LENGTH|INSEAM)\b/];
        if (psoConfig.isBottom) {
        headerPriority = [/\bWAIST\b/, /\bHIPS?\b/, /\b(LENGTH|INSEAM)\b/];
        } else if (psoConfig.isTop && psoConfig.isWomen) {
        headerPriority = [/\bBUST\b/, /\bCHEST\b/, /\bWAIST\b/, /\bHIPS?\b/, /\b(LENGTH|INSEAM)\b/];
        } else if (psoConfig.isTop && psoConfig.isMen) {
        headerPriority = [/\bCHEST\b/, /\bWAIST\b/, /\bHIPS?\b/, /\b(LENGTH|INSEAM)\b/];
        } // pso Liquid branch end

        const firstDataHeader = pickFirstHeader(headers, headerPriority) || headers.find((h, idx) => idx !== 0) || '';
    const bustKey  = pickFirstHeader(headers, [/\bBUST\b/, /\bCHEST\b/]); 
    const waistKey = pickFirstHeader(headers, [/\bWAIST\b/]);
    const hipKey   = pickFirstHeader(headers, [/\bHIPS?\b/]);
    const lenKey   = pickFirstHeader(headers, [/\b(LENGTH|INSEAM)\b/]);

    btns.forEach(btn=>{
      const size = upper(btn.getAttribute('data-value') || btn.textContent);
      const row = rows.find(r => r.SIZE === size) || {};
      const firstVal = row[firstDataHeader] || '';

      const codeEl = btn.querySelector('.sz-code');
      const extraEl = btn.querySelector('.sz-extra');
      if (codeEl) codeEl.textContent = size;
      if (extraEl) extraEl.textContent = firstVal;
      else if (firstVal) btn.innerHTML = '<span class="sz-code">'+size+'</span><span class="sz-extra">'+firstVal+'</span>';

      if (bustKey)  { btn.dataset.bust  = row[bustKey]  || ''; btn.dataset.bustKey  = bustKey; }
      if (waistKey) { btn.dataset.waist = row[waistKey] || ''; btn.dataset.waistKey = waistKey; }
      if (hipKey)   { btn.dataset.hip   = row[hipKey]   || ''; btn.dataset.hipKey   = hipKey; }
      if (lenKey)   { btn.dataset.len   = row[lenKey]   || ''; btn.dataset.lenKey   = lenKey; }
    });

    // If one is already selected, update readout
    const sel = block.querySelector('.variant-btn.selected');
    if (sel) renderReadoutFrom(sel);
  }

  function renderReadoutFrom(btn){
    if (!readoutEl) return;
    const pills = [];
    const bust = btn.dataset.bust, bustKey = btn.dataset.bustKey;
    const waist = btn.dataset.waist, waistKey = btn.dataset.waistKey;
    const hip = btn.dataset.hip, hipKey = btn.dataset.hipKey;
    const len = btn.dataset.len, lenKey = btn.dataset.lenKey;

    function pill(k,v){ return (k && v) ? '<span class="kv-pill"><span class="kv-key">'+k+':</span> '+v+'</span>' : ''; }
    
    pills.push(pill(bustKey, bust)); pills.push(pill(waistKey, waist));
    pills.push(pill(hipKey, hip)); pills.push(pill(lenKey, len));

    const html = pills.filter(Boolean).join('');
    if (html){ readoutEl.innerHTML = html; readoutEl.hidden = false; }
    else { readoutEl.hidden = true; readoutEl.innerHTML = ''; }
  }

  /* --- Render Modal --- */
  function renderLoadingModal() {
    titleEl.textContent = productTitle || 'Size Chart';
    tableEl.innerHTML = '<tr><td style="padding:40px 16px; text-align:center; font-size:14px; border:none;"><div class="ksc-spinner"></div>Fetching sizing data...</td></tr>';
    unitToggle.style.display = 'none';
  }

function renderModal(payload) {
    isModalLoading = false; // Turn off flag
    titleEl.textContent = productTitle || 'Size Chart';
    tableEl.innerHTML = '';

    const measHeadersAll = (payload.headers || []).map(h => (h || '').trim()).filter(h => h && upper(h) !== 'SIZE');
    let measHeaders = measHeadersAll.filter(h => (payload.rows || []).some(rec => (rec[h] || '').trim().length > 0));

    // --- NEW: Dynamic Column Sorting ---
    let headerPriority = [/\bCHEST\b/i, /\bBUST\b/i, /\bWAIST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
    if (psoConfig.isBottom) {
      headerPriority = [/\bWAIST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
    } else if (psoConfig.isTop && psoConfig.isWomen) {
      headerPriority = [/\bBUST\b/i, /\bCHEST\b/i, /\bWAIST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
    } else if (psoConfig.isTop && psoConfig.isMen) {
      headerPriority = [/\bCHEST\b/i, /\bWAIST\b/i, /\bHIPS?\b/i, /\b(LENGTH|INSEAM)\b/i];
    } // pso Liquid branch end

    measHeaders.sort((a, b) => {
        const idxA = headerPriority.findIndex(rx => rx.test(a));
        const idxB = headerPriority.findIndex(rx => rx.test(b));
        // If a column isn't in our priority list, push it to the end (weight 999)
        const weightA = idxA === -1 ? 999 : idxA;
        const weightB = idxB === -1 ? 999 : idxB;
        return weightA - weightB;
    });
    // -----------------------------------

    // Show toggle only if we have measurement data
    if (unitToggle) {
        unitToggle.style.display = measHeaders.length > 0 ? 'flex' : 'none';
    }

    const thead = document.createElement('thead');
    const trh = document.createElement('tr');
    const thRadio = document.createElement('th'); thRadio.className = 'ksc-radio';
    trh.appendChild(thRadio);
    const thSize = document.createElement('th');
    thSize.textContent = 'SELECT SIZE';
    thSize.style.color = '#1155cc'; /* <-- Added color here */
    trh.appendChild(thSize);
    
    measHeaders.forEach(h => {
        const th = document.createElement('th');
        
        // --- NEW: Check for Length to rename header ---
        if (/\b(LENGTH|INSEAM)\b/i.test(h)) {
            th.textContent = 'GARMENT LENGTH';
        } else {
            th.textContent = 'IF YOUR ' + h + ' IS';
        }
        
        trh.appendChild(th);
    });
    thead.appendChild(trh);
    tableEl.appendChild(thead);

    const tbody = document.createElement('tbody');

    payload.rows.forEach(rec=>{
      const size = rec.SIZE;
      const tr = document.createElement('tr');
      const tdRadio = document.createElement('td'); tdRadio.className='ksc-radio';
      const input = document.createElement('input');
      input.type='radio'; input.name='kscSize'; input.value=size; input.setAttribute('aria-label', size);
      tdRadio.appendChild(input); tr.appendChild(tdRadio);

      const tdSize = document.createElement('td'); 
      tdSize.textContent = size;
      tdSize.style.color = '#1155cc'; /* <-- Added color here */
      tdSize.style.fontWeight = '700'; /* Optional: makes it bold so the light color is easier to read */
      tr.appendChild(tdSize);

      measHeaders.forEach(h=>{
        const td = document.createElement('td');
        const origVal = rec[h] || '';
        td.setAttribute('data-orig', origVal); // Keep original text for toggle
        td.className = 'meas-cell';
        td.textContent = convertValue(origVal, currentUnit);
        tr.appendChild(td);
      });

      const variantId = sizeToVariant[size] || null;
      const disabled = !variantId || !!sizeOOS[size];
      if (disabled){ input.disabled = true; tr.setAttribute('aria-disabled','true'); }

      function selectRow(){
        const outOfStockAlert = document.getElementById('out-of-stock-alert');
        if (input.disabled) return;
        modal.querySelectorAll('tbody tr').forEach(r=>r.classList.remove('selected'));
        input.checked = true; tr.classList.add('selected');
        selectedSize = size;

        // Hide warning message if user selects a size row
        const kscWarning = document.getElementById('ksc-size-warning-msg');
        if (kscWarning) kscWarning.style.display = 'none';

        if (sizeOOS[size] && outOfStockAlert) {
          outOfStockAlert.textContent = `The ${size} is currently out of stock.`;
          outOfStockAlert.style.display = 'block';
        } else if (outOfStockAlert) { outOfStockAlert.style.display = 'none'; }
      }

      tr.addEventListener('click', selectRow);
      input.addEventListener('change', selectRow);

      const currentId = variantInput && variantInput.value;
      if (variantId && currentId && variantId === currentId){ setTimeout(selectRow, 0); }
      tbody.appendChild(tr);
    });

    tableEl.appendChild(tbody);
  }

  // Handle IN/CM Toggle Button Clicks
  document.querySelectorAll('.unit-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      if (this.classList.contains('active')) return;
      
      document.querySelectorAll('.unit-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      currentUnit = this.getAttribute('data-unit');
      
      // Update all measurement cells instantly
      document.querySelectorAll('#ksc-modal .meas-cell').forEach(td => {
        td.textContent = convertValue(td.getAttribute('data-orig'), currentUnit);
      });
    });
  });

  function openModal(){ backdrop.style.display='block'; modal.style.display='block'; document.body.style.overflow = 'hidden'; }
  function closeModal(){ modal.style.display='none'; backdrop.style.display='none'; document.body.style.overflow = ''; }

  /* ===== ADD TO CART FROM MODAL LOGIC ===== */
  addBtn.addEventListener('click', function(e){
    e.preventDefault();
    
    const kscWarning = document.getElementById('ksc-size-warning-msg');
    const allMainBtns = document.querySelectorAll('.inline-size-atc .variant-btn');
    const isAllOOS = allMainBtns.length > 0 && Array.from(allMainBtns).every(b => b.classList.contains('out-of-stock') || b.disabled);

    // 1. Check if all sizes are out of stock
    if (isAllOOS) {
      if (kscWarning) {
        kscWarning.textContent = "All sizes are currently out of stock";
        kscWarning.style.display = 'block';
        kscWarning.animate([
          { transform: 'translateX(-4px)' },
          { transform: 'translateX(4px)' },
          { transform: 'translateX(-4px)' },
          { transform: 'translateX(4px)' },
          { transform: 'translateX(0)' }
        ], { duration: 300 });
      }
      return false;
    }

    // 2. Check if size is chosen. If not, trigger warning and halt.
    if (!selectedSize){
      if (kscWarning) {
        kscWarning.textContent = "Please Select a Size";
        kscWarning.style.display = 'block';
        kscWarning.animate([
          { transform: 'translateX(-4px)' },
          { transform: 'translateX(4px)' },
          { transform: 'translateX(-4px)' },
          { transform: 'translateX(4px)' },
          { transform: 'translateX(0)' }
        ], { duration: 300 });
      }
      return false;
    }
    
    // 3. Map size to variant ID
    const vid = sizeToVariant[selectedSize];
    if (!vid || !variantInput) return;

    // 4. Update main form state
    variantInput.disabled = false; 
    variantInput.value = vid;
    try { variantInput.dispatchEvent(new Event('change', {bubbles:true})); } catch(_) {}
    
    const form = document.querySelector('form.atc-form');
    
    // If form isn't found, fallback safely to clicking main page button
    if (!form) {
      const mainBtnToClick = document.querySelector('.scb-main-btn');
      if (mainBtnToClick) mainBtnToClick.click();
      closeModal();
      return;
    }

    // 5. Instant Feedback Visuals for Modal Button
    const originalText = addBtn.innerHTML;
    addBtn.innerHTML = 'ADDING...';
    addBtn.style.pointerEvents = 'none';

    // 6. Fetch Request for instant GoKwik Cart sync
    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(r => r.json())
    .then(function() {
      // Restore Button State
      addBtn.innerHTML = originalText;
      addBtn.style.opacity = '1';
      addBtn.style.pointerEvents = 'auto';
      
      // Close Modal immediately after item is added
      closeModal();

      // Open GoKwik Drawer manually
      if (window.GOKWIK?.cart?.open) { window.GOKWIK.cart.open(); }
      else if (window.GK?.cart?.open) { window.GK.cart.open(); }
      else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    })
    .catch(function(err) {
      console.error(err);
      // Restore Button State on Failure
      addBtn.innerHTML = originalText;
      addBtn.style.opacity = '1';
      addBtn.style.pointerEvents = 'auto';
    });
  });

  modal.querySelector('.ksc-close').addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);

  /* 2026-09-13: the product's own chart arrives inline with the page (custom.size_chart_json), so
     the table and the chips paint immediately. readCache()/the seed file/Kiwi remain the fallbacks. */
  function inlinePayload() {
    var t = psoConfig.chartTable;
    if (!t || !t.headers || !t.rows) return null;
    var rows = Object.keys(t.rows).map(function (sz) {
      var rec = { SIZE: String(sz).toUpperCase() };
      Object.keys(t.rows[sz]).forEach(function (h) { rec[h] = t.rows[sz][h]; });
      return rec;
    });
    if (!rows.length) return null;
    return { ts: Date.now(), headers: ['SIZE'].concat(t.headers), rows: rows };
  }

  /* --- Initialization & Live Observation --- */
  var inlined = inlinePayload();
  globalPayload = inlined || readCache();
  if (globalPayload) {
    hydrateSwatches(globalPayload);
    if (inlined) writeCache(inlined);   // seeds the shared key so the overlay and other engines skip the fetch too
  }
  window.__kwSeedDone = function () {
    if (!globalPayload) {
      var p2 = readCache();
      if (p2) {
        globalPayload = p2;
        hydrateSwatches(p2);
        if (isModalLoading) { isModalLoading = false; renderModal(p2); }   // swap the spinner for the table
      }
    }
  };
  (function () {
    if (window.__kwSeed) return; window.__kwSeed = 1;
    if (inlined) return;            // this product's chart came with the page; the 50KB seed is not needed
    var needNow = !globalPayload;   // no local chart for this product: fetch now, stamp or no stamp
    try { var g = (localStorage.getItem('saadaaKiwiSeedV') || '').split('|'); if (!needNow && g[0] === 'v1' && Date.now() - (+g[1] || 0) < 432000000) return; } catch (e) {}
    fetch(psoConfig.seedUrl).then(function (r) { return r.json(); }).then(function (m) {
      var ts = Date.now();
      Object.keys(m).forEach(function (id) {
        try { if (m[id] && m[id].rows && (!localStorage.getItem('saadaaKiwiC:' + id) || id === KIWI_CHART_ID)) localStorage.setItem('saadaaKiwiC:' + id, JSON.stringify({ ts: ts, headers: m[id].headers, rows: m[id].rows })); } catch (e) {}
      });
      try { localStorage.setItem('saadaaKiwiSeedV', 'v1|' + Date.now()); } catch (e) {}
      if (window.saadaaHydrateOverlayKiwi) { try { saadaaHydrateOverlayKiwi(); } catch (e) {} }
      if (window.__kwSeedDone) { try { window.__kwSeedDone(); } catch (e) {} }
    }).catch(function () {});
  })();


  function checkLive() {
    const p = extractFromDOM();
    if (p && p.rows && p.rows.length > 0) {
      globalPayload = p;
      writeCache(p);
      hydrateSwatches(p);
      if (isModalLoading) renderModal(p); // If user is staring at spinner, switch to table!
      return true;
    }
    return false;
  }

  if (!checkLive()) {
    // Attempt to wake up Kiwi in the background
    setTimeout(() => {
      const trigger = document.querySelector('#KiwiSizingChart');
      if (trigger) trigger.click();
    }, 100);

    // Watch the DOM infinitely. No timeouts. 
    // The exact moment Kiwi injects its table, this fires.
    const mo = new MutationObserver(() => {
      if (checkLive()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Hook up the Size Chart Button
  document.querySelectorAll('.ks-open-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (globalPayload && globalPayload.rows && globalPayload.rows.length > 0) {
        renderModal(globalPayload);
      } else {
        isModalLoading = true;
        renderLoadingModal();
      }
      openModal();
    });
  });

  // Keep swatches reactive
  document.addEventListener('click', (e)=>{
    const btn = e.target.closest('.inline-size-atc .variant-btn');
    if (!btn || btn.classList.contains('out-of-stock') || btn.disabled) return;
    renderReadoutFrom(btn);
  });
  if (variantInput){
    variantInput.addEventListener('change', function(){
      const btn = block.querySelector('.variant-btn[data-variant-id="'+this.value+'"]');
      if (btn) renderReadoutFrom(btn);
    });
  }

})();
  
})();
